import { useTranslation } from "react-i18next"
import { TextButton } from "../../components/Form/Button/TextButton"

export const InvoiceStatus = ({row, label}) => {
    const {t} = useTranslation();
    if(row.status === 1){
        return (
            <TextButton color={"success"} label={label}>
                {t("Processed")}
            </TextButton>
        )
    }
    if(row.status === 2){
        return (
            <TextButton color={"danger"} label={label}>
                {t("Unpaid")}
            </TextButton>
        )
    }
    return (
        <TextButton color={"warning"} label={label}>
            {t("Issued")}
        </TextButton>
    )
}